import { getButtonLabel } from './flowButtons';

/** QUICK_REPLY rows from Meta template BUTTONS component */
export function extractTemplateQuickReplyButtons(templateSections) {
  const comp = templateSections?.buttons;
  if (!comp) return [];
  const list = comp.buttons ?? (Array.isArray(comp) ? comp : []);
  return list
    .filter((b) => b?.type === 'QUICK_REPLY' && b?.text)
    .map((b) => ({
      id: String(b.text),
      label: String(b.text),
    }));
}

/** Keep target_node_id when template or labels change */
export function mergeTemplateButtons(fromTemplate, existing = []) {
  return fromTemplate.map((tb) => {
    const prev = existing.find(
      (e) => e.id === tb.id || getButtonLabel(e) === tb.label || e.id === tb.label
    );
    return {
      ...tb,
      label: tb.label,
      target_node_id: prev?.target_node_id,
      capture_var: prev?.capture_var,
    };
  });
}
